import React, { FC } from 'react';
import HyperLink, { ENTITY_TYPE } from '../common/HyperLink';
import {
	getPurchaseOrderId,
	getPurchaseRequestId,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import { PpslAudit } from '../../types/ppsl_audits';

interface PartAuditReferencesProps {
	record: PpslAudit;
}

export const getPartAuditReferences = (record: Partial<PpslAudit>) =>
	[
		record.workOrderId && {
			key: 'workOrder',
			text: `WO #${record.workOrderId}`,
			entityType: ENTITY_TYPE.WORK_ORDER,
			entityId: record.workOrderId,
		},
		record.purchaseOrderId && {
			key: 'purchaseOrder',
			text: `PO ${getPurchaseOrderId(
				nullSafeGetOrElse('purchaseOrder', record, { id: record.purchaseOrderId })
			)}`,
			entityType: ENTITY_TYPE.PURCHASE_ORDER,
			entityId: record.purchaseOrderId,
		},
		record.purchaseRequestId && {
			key: 'purchaseRequest',
			text: `PR ${getPurchaseRequestId(
				nullSafeGetOrElse('purchaseRequest', record, { id: record.purchaseRequestId })
			)}`,
			entityType: ENTITY_TYPE.PURCHASE_REQUEST,
			entityId: record.purchaseRequestId,
		},
		record.transferredToStockLocationId && {
			key: 'transferredTo',
			text: `To ${nullSafeGetOrElse(
				'transferredToStockLocation.name',
				record,
				`SL #${record.transferredToStockLocationId}`
			)}`,
			entityType: ENTITY_TYPE.STOCK_LOCATION,
			entityId: record.transferredToStockLocationId,
		},
		record.transferredFromStockLocationId && {
			key: 'transferredFrom',
			text: `From ${nullSafeGetOrElse(
				'transferredFromStockLocation.name',
				record,
				`SL #${record.transferredFromStockLocationId}`
			)}`,
			entityType: ENTITY_TYPE.STOCK_LOCATION,
			entityId: record.transferredFromStockLocationId,
		},
	].filter(Boolean);

const PartAuditReferences: FC<PartAuditReferencesProps> = ({ record }): React.ReactElement => {
	const references = getPartAuditReferences(record);
	return references.length > 0 ? (
		<div className="flex flex-col gap-1">
			{references.map((reference) => (
				<HyperLink
					key={reference.key}
					text={reference.text}
					entityType={reference.entityType}
					entityId={reference.entityId}
					backLinkText="Back to Part"
				/>
			))}
		</div>
	) : (
		<>--</>
	);
};

export default PartAuditReferences;
